import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mapfre-create-password-form',
  templateUrl: './create-password-form.component.html',
  styleUrls: ['./create-password-form.component.scss']
})
export class CreatePasswordFormComponent {

  @Input() form;
  checksPassword = [
    {
      title: 'REGISTER.CREATE_PASSWORD.CHECKS_PASSWORD.CHECK1',
      check: () => this.checkHasNumberPassword(),
    },
    {
      title: 'REGISTER.CREATE_PASSWORD.CHECKS_PASSWORD.CHECK2',
      check: () => this.checkLongerPassword(),
    },
    {
      title: 'REGISTER.CREATE_PASSWORD.CHECKS_PASSWORD.CHECK3',
      check: () => this.checkNonSpecialCharacterPassword(),
    }
  ];

  constructor(private translate: TranslateService) { }

  checkHasNumberPassword() {
    const controlPasswordError = this.form.get('newPassword')?.errors;
    return controlPasswordError?.hasNumber;
  }

  checkLongerPassword() {
    const controlPasswordError = this.form.get('newPassword')?.errors;
    return controlPasswordError?.minlength && !controlPasswordError?.required ||
      !controlPasswordError?.hasOwnProperty('minlength') && controlPasswordError?.required;
  }

  checkNonSpecialCharacterPassword() {
    const controlPasswordError = this.form.get('newPassword')?.errors;
    return controlPasswordError?.validNonSpecialCharacter && !controlPasswordError?.required ||
      !controlPasswordError?.hasOwnProperty('validNonSpecialCharacter') && controlPasswordError?.required;
  }

  checkHasErrorsConfirmPassword() {
    const controlConfirmPassword = this.form.get('confirmPassword');
    if (controlConfirmPassword?.dirty && controlConfirmPassword?.errors?.required) {
      return true;
    }

    if (controlConfirmPassword?.dirty && controlConfirmPassword?.errors?.validMatch && !controlConfirmPassword?.errors?.required) {
      return true;
    }
    return false;
  }

  changeErrorTextConfirmPassword(): string | void {
    const controlConfirmPassword = this.form.get('confirmPassword');
    if (controlConfirmPassword?.dirty && controlConfirmPassword?.errors?.required) {
      return this.translate.instant('REQUIRED_DATA');
    }
    if (controlConfirmPassword?.dirty && controlConfirmPassword?.errors?.validMatch && !controlConfirmPassword?.errors?.required) {
      return this.translate.instant('REGISTER.ERRORS.CREATE_PASSWORD.HINT');
    }
  }

  alphaNumberOnly(e) {
    const regex = new RegExp(/^[a-zA-Z0-9]*$/g);
    const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

}
